import { IDBPDatabase } from 'idb'

import asyncForEach from 'utils/asyncForEach'

import { IDBSchema } from '../types'

/**
 * CHANGES:
 * - Rename `field` to fieldIds for every IScriptSchema IScriptWhereCreatePayload
 */
export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v13---')

  const scriptStore = transaction.objectStore('scripts')

  // First, we get all the scripts
  const scriptsRequest = scriptStore.getAll()
  scriptsRequest.onsuccess = () => {
    const scripts = scriptsRequest.result
    STUDIO_ENV_DEVELOPMENT && console.log('Found all scripts', scripts)

    asyncForEach(
      scripts,
      (script, next) => {
        // Update each script's where item
        script.where = script.where.map((where: any) => {
          where.fieldIds = [where.fieldId]
          delete where.fieldId
          STUDIO_ENV_DEVELOPMENT && console.log('Updated where', where)
          return where
        })
        scriptStore.put(script).onsuccess = next
      },
      () => {
        STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v13---')
        return next()
      }
    )
  }
}
